import { BaseFiltroPagDTO } from "./base-dto";

interface IOperator {
  operator: string;
  descricao: string;
}

interface IType {
  tipo: string;
  descricao: string;
  operadores: IOperator[];
}

interface IProperty {
  id: number;
  descricao: string;
  tipo: IType;
  valor: string;
}

interface IRule {
  id?: string;
  codigo?: string;
  descricao: string;
  acao: string;
  mensagem: string;
  textoExplicativo: string;
  solicitarCiente: boolean;
  palavraChaveCiente: string;
  condicoes: any[];
  peso: string;
  hierarquia: TypeRuleReference;
  ativo: boolean;
}

type TypeRuleReference = 'EMEDE' | 'CLIENTE' | 'TIME' | 'MEDICO' | 'PACIENTE';

interface IRuleOverride extends IRule {
  sobrescreve: any;
  hierarquia: TypeRuleReference;
  referenciaHierarquia: string;
  unidade: any;
}

export class CondicaoParmDTO {
  entidade: string;
  campo: string;
  operador: string;
  idPropriedade: string;
}
export class RestricaoParmDTO {
  id: Number;
  codigo: string;
  descricao: string;
  acao: string;
  mensagem: string;
  textoExplicativo: string;
  solicitarCiente: boolean;
  palavraChaveCiente: string;
  hierarquia: string;
  referenciaHierarquia: string;
  idUnidade: Number;
  idSobrescreve: Number;
  ativo: boolean;
  motivoAlteracao: string;

  condicoes: CondicaoParmDTO[];
}

export class RestricaoFiltroPagDTO extends BaseFiltroPagDTO {
  termos: string;
  acao: string;
  ativo: Boolean;
}

export class RestricaoHierarquiaFiltroPagDTO extends BaseFiltroPagDTO {
  idRestricao: number;
  hierarquia: string;
  referenciaHierarquia: number;
  ativo: Boolean;
}

export { IOperator, IType, IProperty, IRule, IRuleOverride, TypeRuleReference };
